sap.ui.define(["sap/ui/core/library", 'sap/uxap/BlockBase'], function (coreLibrary: any, BlockBase: any) {
	"use strict";

	var ViewType = coreLibrary.mvc.ViewType;

	var Transactions = BlockBase.extend("com.reply.leaviosa.blocks.transactions.Transactions", {
		metadata: {
			views: {
				Collapsed: {
					viewName: "com.reply.leaviosa.blocks.transactions.Transactions",
					type: ViewType.XML
				},
				Expanded: {
					viewName: "com.reply.leaviosa.blocks.transactions.Transactions",
					type: ViewType.XML
				}
			}
		}
	});
    
	return Transactions;
});